import React from 'react';

/**
 * Trust + company signature block.
 * Use inside an existing <footer>. Variant "dark" for black footers, "light" for white pages.
 */
export default function FooterTrust({ variant = "dark" }) {
  const noteColor = variant === "dark" ? "text-gray-300" : "text-gray-600";
  const accentColor = variant === "dark" ? "text-white" : "text-gray-900";
  const companyColor = variant === "dark" ? "text-gray-200" : "text-gray-700";
  const borderColor = variant === "dark" ? "border-gray-700/70" : "border-gray-200";
  const shieldColor = variant === "dark" ? "text-emerald-400" : "text-emerald-600";

  return (
    <div className={`border-t ${borderColor} pt-5 mt-5 space-y-2`}>
      <p className={`font-manrope text-xs ${noteColor} text-center max-w-2xl mx-auto leading-relaxed`} data-testid="footer-trust-note">
        <span className={`inline-flex items-center gap-1 ${shieldColor} font-semibold`}>
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
          Secure
        </span>
        {" — "}TelegramEmailBot does <strong className={accentColor}>not store email passwords</strong> and only processes notifications authorized by users. All traffic is encrypted via HTTPS.
      </p>
      <p className={`text-xs ${companyColor} font-manrope text-center`} data-testid="footer-company-name">
        Operated by <strong className={accentColor}>Mii Global Partner Holdings Sdn. Bhd.</strong> · Reg. No. 202601028203 (1690298-K) · Penang, Malaysia
      </p>
    </div>
  );
}
